define('uikit/elements/text',['require','exports','module','underscore','marionette','../mixins/component.mixin','../channel','templates'],function(require, exports, module){
  var _ = require('underscore');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Templates = require('templates');

  var TextView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'text',

    tagName: 'span',

    options: {
      visible       : true,
      color         : '',
      text          : '',
      formatter     : null,
      underline     : false,
      strikethrough : false,
      renderAsHtml  : false
    },

    forceUpdate: { visible: true, text: true, formatter: true },

    template: Templates.App['text'],

    serializeData: function() {
      var data = ComponentMixin.serializeData.apply(this, arguments);

      if (_.isFunction(this.formatter)) {
        data.text = this.formatter(this.text);
      }

      return data;
    },

    updateAttributes: function() {
      this.addClass(this.getOption('color'), this.getBoolOption('color')),
      this.addClass('underline', this.getBoolOption('underline')),
      this.addClass('strikethrough', this.getBoolOption('strikethrough'))
    }

  });

  // register the table component
  channel.reply('text', function() {
    return TextView;
  });

  module.exports = TextView;

});

